import cn from 'clsx'

import { NavLink, ImageBox } from 'shared-components'

import s from './Story.module.sass'

function Story({ story }: any) {
    const { subtitle, title, copy, image, link } = story

    return (
        <li className={s.Story}>
            <NavLink href={link || '#'}>
                <div className={s.Image}>
                    {image && <ImageBox image={image} alt={title || ''} width={500} height={500} />}
                </div>
                <div className={s.Content}>
                    {subtitle && <div className="smallCaps" dangerouslySetInnerHTML={{ __html: subtitle }} />}
                    {title && <h4 dangerouslySetInnerHTML={{ __html: title }} />}
                    {copy && <div className={s.Copy} dangerouslySetInnerHTML={{ __html: copy }} />}
                </div>
            </NavLink>
        </li>
    )
}

export default Story
